import { CondOperator } from '@nestjsx/crud-request';
import { Filter, FilterOptions } from './filter';

export abstract class AutocompleteFilter extends Filter {
  type: 'autocomplete' = 'autocomplete';

  constructor(typeName: string, options: Omit<FilterOptions, 'type' | 'allowedOperators'>) {
    super(typeName, { ...options, type: 'select', allowedOperators: [CondOperator.EQUALS, CondOperator.NOT_EQUALS] });
  }

  abstract getImageUrl(value: any): string | null | undefined;
  abstract getAutocompleteHtml(value: any): string;

  compareWith(value1: any, value2: any): boolean {
    return value1 === value2;
  }
}
